import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../../stores/Auth/AuthStore';
// import useOpenCloseAuthModalStore from "../../stores/Auth/useAuthModal"
import { useOpenCloseAuthModalStore } from '../../stores/Auth/useAuthModal';
const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, user } = useAuthStore();
    const location = useLocation();
    const {open} = useOpenCloseAuthModalStore()
    if (!isAuthenticated || !user) {
        // Redirect to login page with return url
        open()
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;